import {
  computed,
  toRef,
} from "vue";

import {
  toFormElementFromParameter,
} from "../../../../../../global/functions/mappingForParameterToFormElement";

export default function OptionsAPI(props) {
  const options = toRef(props, "options");

  const jsonParam = computed(() => {
    return {
      bez: "_LBL_GR_ASTAUSWAHL_TYP_CONFIGS_ASTORGTYP_",
      default: null,
      help_text: "_LBL_GR_ASTAUSWAHL_TYP_CONFIGS_ASTORGTYP_HLEPTEXT_",
      readonly: false,
      options: {
        allow_null: false,
        required: true,
      },
      typ: "validated_json",
      many: true,
      as_json: false,
      key_field: null,
      pos_field: null,
      min_length: true,
      max_length: null,
      element_label: "Element",
      element_template: "{{astorgtyp}}",
      element_errors: true,
      fields: {
        astorgtyp: {
          prio: 0,
          bez: "_LBL_GR_ASTAUSWAHL_TYP_ASTORGTYP_",
          readonly: false,
          options: {
            allow_null: true,
            required: true,
            displaymode: "select2",
          },
          keyLabel: "bez",
          typ: "single_choice",
          katalog: "antragstellerorgtyp",
        },
        felder: {
          prio: 10,
          bez: "_LBL_GR_ASTAUSWAHL_TYP_FELDER_",
          help_text: "",
          readonly: false,
          many: true,
          default: () => [],
          options: {
            allow_null: true,
            required: false,
            displaymode: "select2",
            many: true,
          },
          typ: "multiselect",
          choices: [
            ["anrede", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_ANREDE_"],
            ["titel", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_TITLE_"],
            ["ast_vorname", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_VORNAME_"],
            ["ast_nachname", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_NACHNAME_"],
            ["ast_name", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_NAME_"],
            ["ast_namezusatz", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_NAMESZUSATZ_"],
            ["ast_strasse", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_STRASSE_"],
            ["ast_hsnr", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_HAUSNR_"],
            ["ast_plz", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_PLZ_"],
            ["ast_ort", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_ORT_"],
            ["bundesland", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_BUNDESLAND_"],
            ["lkz", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_LKZ_"],
            ["rechtsform", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_RECHTSFORM_"],
            ["ast_email", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_EMAIL_"],
            ["ast_url", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_URL_"],
            ["ast_telefon", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_TELEFON_"],
            ["ast_mobil", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_MOBIL_"],
            ["foerderorg", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_FOERDERORG_"],
            ["ast_beschreibung", "_LBL_GR_ANTRAGSTELLER_AST_ORG_TYP_BESCHREIBUNG_"],
            ["ast_geburtsdatum", "_TXT_AST_BASISDATEN_PARAMETER_GEBURTSDATUM_"],
            ["ast_geburtsort", "_TXT_AST_BASISDATEN_PARAMETER_GEBURTSORT_"],
            ["staatsangehoerigkeit", "_TXT_AST_BASISDATEN_PARAMETER_STAATSANGEHOERIGKEIT_"],
          ]
        },
        asp_auswahl: {
          prio: 20,
          bez: "_LBL_GR_ASTAUSWAHL_TYP_ASP_AUSWAHL_",
          default: false,
          help_text: "",
          readonly: false,
          typ: "boolean",
        },
        dufo_auswahl: {
          prio: 30,
          bez: "_LBL_GR_ASTAUSWAHL_TYP_DUFO_AUSWAHL_",
          default: false,
          help_text: "",
          readonly: false,
          typ: "boolean",
        },
      },
    };
  });

  const jsonOptions = computed(() => {
    return toFormElementFromParameter({
      obj: { antragsteller_auswahl_typconfig: jsonParam.value },
      showLabel: true,
      staticOptions: {
        required: options.value?.required,
        options: options.value?.options,
      },
    }).list[0];
  });

  return {
    jsonOptions,
  };
}
